module.exports = __webpack_public_path__ + "img/welcome-page.2f2bd5c7.png";